// redux/dismissNotification.js
import { HOME_DISMISS_NOTIFICATION } from './constants';
import { BFFAgent } from 'BFFAgent'; // Asegúrate de que esta importación apunte al lugar correcto

export function dismissNotification(id, userId) {
  return async (dispatch, getState) => {
    try {
      // Llamada al BFF para marcar la notificación como leída
      await BFFAgent.Notifications.markAsRead(id, userId);

      // Luego de marcarla como leída en el backend, actualizamos el estado del frontend
      const notifications = getState().home.notifications.filter(notification => notification.id !== id);
      dispatch({
        type: HOME_DISMISS_NOTIFICATION,
        payload: notifications,
      });
    } catch (error) {
      console.error('Error al marcar la notificación como leída:', error);
    }
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_DISMISS_NOTIFICATION:
      return {
        ...state,
        notifications: action.payload,
      };

    default:
      return state;
  }
}
